module.exports = __webpack_public_path__ + "static/assets/a068978055dc27f3ef598241544784e2.svg";